<template>
  <div>
    <div class="fc-text-center fc-mar-t-biger">
      <div class="fc-bg-fff fc-pad-b-sm">
        <img class="login_logo" src="../../assets/img/logo.png">
        <p class="fc-text-bigabit fc-mar-t fc-pad-lr-biger">{{$t('m.scanLogin')}}</p>
        <div class="fc-relative">
          <div id="qrcode" class="qrcode">
            <img :src="qrcodeUrl" alt="" v-if="qrcodeUrl">
            <div class="fail_mask" @click="getQrcodeInfo()" v-if="qrCodeTimeOut">
              <img class="qrcode_ref_icon" src="../../assets/img/refresh.png">
            </div>
          </div>

        </div>
        <p class="login_tip">{{$t('m.scanTip')}}</p>
        <p class="login_tip">(<span id="scanVersion">{{moreLang.scanVersion}}</span>)</p>
      </div>
      <!-- <p class="fc-notice" v-html="moreLang.buyNoticeA"></p> -->

    </div>
    <p class="fc-notice loginLesson">
      <!-- <img src="../../assets/img/question_icon.png" class="fc-icon-sm"> -->
      <a class="" @click="gotoask">{{$t('m.scan_login_lesson')}}</a>
    </p>
  </div>
</template>
<script>
  import Vue from 'vue';
  import QRCode from 'qrcode';
  import { getQrcodeInfoAjax,checkQrcodeAjax } from '../../api/index';
  import {
    Toast
  } from 'vant';
  Vue.use(Toast);
  var _self;
  export default {
    name: 'LoginScan',
    data() {
      return {
        token: '',
        isLunxun: true,
         qrcode: '',
        qrcodeUrl: '',
        qrCodeTxt: 'https://www.facecast.live/x/',
        qrCodeMd5: '',
        timer: null,
        qrCodeTimeOut: false,
        moreLang: {
          "scanVersion": '',
          "buyNoticeA": '',
        },
      }
    },
    mounted() {
      this.$analytics.logEvent('pay_scan', {
        'app_name': 'H5充值',
        'screen_name' : '扫码登录'
      });
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        icon: require("../../assets/img/loading.gif"),
        className: 'loading'
      });
      _self = this;
      _self.qrcodeUrl = '';
      _self.getMoreLang();
      _self.getQrcodeInfo();
    },
    destroyed() {
      //console.log("ending");
      _self.isLunxun = false;
      _self.qrcodeUrl = '';
    },
    methods: {
      gotoask() {
        _self.isLunxun = false;
        _self.$router.push({
          name:'loginCourse'
        })
      },
      selCountryConfirm(val, index) {
        //console.log(val);
        _self.currentCountryIndex = index;
        _self.showcountryPicker = false;
      },
      getMoreLang() {
        let str = _self.$i18n.t('m.scanVersion');
        let a = str.replace(/%s/g, '2.5.72');
        _self.moreLang = {
          "scanVersion": a,
          "buyNoticeA": _self.$i18n.t('m.buy-notice-a', {msg: window.location.host})
        };
      },

      initQrcode(url) {
        QRCode.toDataURL(url, {
            width: 300,
            height: 300,
            type: 'image/jpeg',
            quality: 0.3,
            margin: 1
          })
          .then(url => {
            //console.log(url);
            _self.qrcodeUrl = url;
            _self.qrCodeTimeOut = false;
          })
          .catch(err => { //异常时的处理
            console.error(err)
          })


      },
      getQrcodeInfo() {
        getQrcodeInfoAjax().then(({data}) => {
          Toast.clear();
          console.log(data);
          if (data.code == 1) {
            _self.qrCodeMd5 = data.data.keyCode;
            _self.initQrcode(_self.qrCodeTxt + _self.qrCodeMd5);
            _self.isLunxun = true;
            _self.checkQrcode();
          }
        }).catch((error) => {
          console.log(error) //  错误处理 相当于error
          _self.qrCodeTimeOut = true;
          Toast.clear();
        })
      },
      //检查qrcode是否有效
      checkQrcode() {
        checkQrcodeAjax({
          "keyCode":_self.qrCodeMd5,
          "platform":1
        }).then(({data}) => {
          //console.log(data);
          switch (data.code) {
            // 1-已登录 101-已过期 102-未扫码 103-已扫码 未登录
            case 1:
              this.$analytics.logEvent('pay_scan_login', {
                scanType: '已扫码，登录成功',
              });
              _self.isLunxun = false;
              localStorage.setItem("userInfo", JSON.stringify(data.data));
              _self.$router.replace({
                path: '/'
              })
              break;
            case 101:
                //Toast('已过期');
                _self.isLunxun = false;
                _self.qrCodeTimeOut = true;
                //clearInterval(_self.timer);
              break;
            case 102:
              _self.qrCodeTimeOut = false;
              break;
            default:
              break;
          }
          if (_self.isLunxun) {
            setTimeout(function() {
              _self.checkQrcode();
            }, 1000);
          }

        }).catch((error) => {
          console.log(error);
          _self.isLunxun = false;
          _self.qrCodeTimeOut = true;
        })
      },

    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loginLesson{
  color: #008AFF;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginScan.vue